import { ADDITIONAL_PAGE_OPTIONS } from '@vfde-sails/constants';

/**
 * Check if tauschbonus can be selected for this device/saleschannel
 */
export const getIsTauschbonusEligible = (): boolean => window[ADDITIONAL_PAGE_OPTIONS]?.promos?.tauschbonus !== undefined;
